import { EXLY_TABLE_EMPTY_STATES_VERSIONS } from "common/Components/ExlyTable/ExlyTableEmptyState/constants/ExlyTableEmptyState.constants";
import SessionStorageConstants from "constants/SessionStorage.constants";
import { getSubdomain } from "features/Account/utils/getCreatorPageDetails";
import { EXLY_EMPTY_STATE_SECONDARY_CTA_VARIANTS } from "features/Common/modules/ExlyEmptyState/constants/ExlyEmptyState.constants";
import { TRANSACTIONS_LEARN_MORE_HREFS } from "features/Transactions/modules/GSTDetailsField/constants/Transactions.constants";
import { is_empty } from "utils/validations";

export const TRANSACTIONS_REFUND_OPTIONS = {
  REFUND_LISTING_PRICE: 1,
  CHARGE_IHF_TO_CUSTOMERS: 2,
  REFUND_CUSTOM_AMOUNT: 3,
};

export const TRANSACTION_STATUS_KEYS = {
  PENDING: 1,
  RECEIVED: 2,
  TRANSFERRED: 3,
  REFUNDED: 4,
  CANCELLED: 5,
  AUTHORIZED: 6,
  PROCESSING: 7,
  FAILED: 8,
  SUBSCRIPTION_CREATED: 9,
};

export const PAYOUT_STATUSES = {
  refund_initiated: "Refund Initiated",
  refunded: "Refunded",
};

export const TRANS_CONSTANTS = {
  place_after_decimal: 2,
  free: "free",
  order: "order",
  all_transaction: "all_transaction",
  receipt_url: "receipt_url",
};

export const POSTFIX_RETURN_URL = "payments/exly/transactions/list";

export const emptyStateProps = {
  version: EXLY_TABLE_EMPTY_STATES_VERSIONS.V2,
  title: "No transactions yet",
  description:
    "As soon as we have a new transaction, it will show up here. View the video to learn more.",
  videoSrc: TRANSACTIONS_LEARN_MORE_HREFS.ALL_TRANSACTIONS_VIDEO,
  secondaryCtaProps: {
    variant: EXLY_EMPTY_STATE_SECONDARY_CTA_VARIANTS.learn_more,
    learnMoreHref: TRANSACTIONS_LEARN_MORE_HREFS.MANAGE_TRANSACTIONS,
  },
  primaryCtaProps: {
    title: "Add a session",
    onClick: () => {
      window.sessionStorage.setItem(
        SessionStorageConstants.FROM_ROUTE,
        "All Transactions"
      );
      window.location.href = !is_empty(getSubdomain())
        ? `${window.location.origin}/#/ScheduleList`
        : `${window.location.origin}/#/TemplatePreview`;
    },
  },
  className: "mt-4",
};
